import { render, staticRenderFns } from "./shift_setting.vue?vue&type=template&id=8fc4a128&scoped=true&"
import script from "./shift_setting.vue?vue&type=script&lang=js&"
export * from "./shift_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc4a128",
  null
  
)

export default component.exports